import { render, staticRenderFns } from "./chatbot-modal.vue?vue&type=template&id=60b2cdec"
import script from "./chatbot-modal.vue?vue&type=script&lang=js"
export * from "./chatbot-modal.vue?vue&type=script&lang=js"
import style0 from "./chatbot-modal.vue?vue&type=style&index=0&id=60b2cdec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports